var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{staticStyle:{"overflow":"hidden"},attrs:{"active":_vm.active},on:{"close":function($event){_vm.active=false}}},[_c('div',{staticClass:"box",staticStyle:{"overflow":"hidden"},attrs:{"id":"temperatureHistogram"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }